// extracted by mini-css-extract-plugin
export default {"head":"index_head_BAL0h","icon":"index_icon_cOfuV"};